module.exports = __webpack_public_path__ + "static/media/promo-sonder.d14005cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/promo-sonder.jpg
// module id = 320
// module chunks = 0